import PropTypes from 'prop-types';
import React from 'react';
import ModalBox from '../../../shared/modal';

const Form = props => {
	return (
		<div>{
			props.dailyApproveList.map((item, index) =>
				<p key={index}>{item.offer} - {item.country} - {item.affiliate_id}</p>
			)
		}
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl(`Affiliate has active daily approve settings!`)}
		body={Form(props)}
		isOpen={props.showDailyApprovePopup}
		onClose={props.toggleDailyApprovePopup}
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-approve/components/popups/daily-approve-popup.js